<div class="ptb-100">
    <div class="container-fluid bg-secondary p-3 d-flex align-items-center">
        <div class="container d-flex ">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item active" aria-current="page" (click)="home()">Home</li>
                    <li class="breadcrumb-item active" aria-current="page">Subscription</li>
                </ol>
            </nav>
        </div>
    </div>
    <div class="container d-flex justify-content-center">
        <div class="row  mt-3 mb-5 mobilee">
            <div class="col-lg-12">
                <div class="border p-4 shadow rounded-5">
                    <div class="tab-pane fade show" >
                        <h4>Subscription Detail</h4>
                        <hr /> 
                        <div *ngFor="let item of Packagedata">
                            <div class="card width-400">
                                <h6>{{item.PackageName}}</h6><br />
                                <p class="notecont mb-4">{{item.PackageDescription}}</p>
                                <p class=" mb-4">{{item.PackageDuration}}</p>
                                <p class="notecont mb-3">PRICE:<b>{{item.PackagePrice}}.00</b></p>
                                <p class="notecont ">{{item.PaymentMode}}</p>
                                <img class="scanner" src="../../../assets/img/ScanerImag.jpeg" />
                                <div class="notecont"><b>NOTE: </b>Please Enter Your TransctionID For Quick Verification</div>
                                <div class="d-flex">
                                    <input class="subscription" [(ngModel)]="TransctionID" placeholder="Enter TransctionID" />
                                    <button class="btn btn-danger submit" (click)="Subscribedd()">Submit</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
